import config from '@/config'
import axios from 'axios'

const bulkProcess = {
  state: {},
  actions: {
    async searchCategoryCodeBulkJob (_, payload) {
      const page = payload && payload.page ? payload.page : 1
      const pageSize = payload && payload.pageSize ? payload.pageSize : 10

      try {
        const { data } = await axios.get(
          `${config.ENDPOINTS.CAT4MRO_APIHTTP}/api/category-codes/jobs`,
          {
            params: { page, pageSize }
          }
        )
        return data
      } catch (e) {
        console.error('SEARCH FAILURE', e)
        throw e
      }
    },
    async uploadCategoryCodeFile ({ rootState }, formData) {
      const userEmail = rootState.auth && rootState.auth.currentUser
        ? rootState.auth.currentUser.email
        : null
      return axios.post(`${config.ENDPOINTS.CAT4MRO_APIHTTP}/api/category-codes/bulk-update`, formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'x-user-email': userEmail
          }
        }
      ).then(function (response) {
        return response.data
      }).catch(function (e) {
        console.error('UPLOAD FAILURE')
        return Promise.reject(e)
      })
    },
    async getJobStatusCategoryCode (_, jobId) {
      try {
        const { data } = await axios.get(
          `${config.ENDPOINTS.CAT4MRO_APIHTTP}/api/category-codes/bulk-update/${jobId}/status`
        )
        return data
      } catch (e) {
        console.error('SEARCH POLLING FAILURE', e)
        throw e
      }
    },
    async reprocessCategoryCodeBulkJob (_, jobId) {
      try {
        const { data } = await axios.post(
          `${config.ENDPOINTS.CAT4MRO_APIHTTP}/api/category-codes/bulk-update/${jobId}/reprocess`
        )
        return data
      } catch (e) {
        console.error('REPROCESS CATEGORY CODE BULK JOB FAILURE', e)
        throw e
      }
    }
  },
  mutations: {},
  getters: {}
}

export default bulkProcess



// WEBPACK FOOTER //
// ./src/store/modules/processes.js